// extracted by mini-css-extract-plugin
export default {"loanSummary":"LoanSummary_loanSummary__6PksP","header":"LoanSummary_header__57vmt","backArrow":"LoanSummary_backArrow__nm4fg","paymentAmount":"LoanSummary_paymentAmount__zo+sL"};